import {AsyncComponent} from '@modifi/code-splitting'
import {FullScreenLoader} from '@modifi/ui'

export default AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "cms-page" */ '.'),
  loader: FullScreenLoader,
  modules: ['cms-page'],
  webpack: [require.resolveWeak('.')],
})
